import { Action } from 'redux';
import { AssetUpload } from '@webapp/types/assets/asset-upload';
import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { AssetUploadResponse } from '../../sdk/assets';
import { ErrorAction } from '../common/error-action';
import { AssetValidationResults } from '@services/asset/types/asset-validation-results';

export class CreateAsset implements LoadingAction {
  readonly type = actions.CREATE_ASSET;
  readonly isLoading = true;

  constructor(
    public assetType: string,
    public file: File,
    public metadata?: any,
    public trackingId?: string
  ) {}
}

export class ReplaceAsset implements LoadingAction {
  readonly type = actions.REPLACE_ASSET;
  readonly isLoading = true;

  constructor(
    public assetId: string,
    public assetType: string,
    public file: File,
    public metadata?: any,
    public trackingId?: string
  ) {}
}

export class ReplaceAssetSuccess implements LoadingAction {
  readonly type = actions.REPLACE_ASSET_SUCCESS;
  readonly isLoading = false;

  constructor(
    public assetType: string,
    public fileName: string,
    public size: number,
    public response: AssetUploadResponse,
    public metadata?: any,
    public trackingId?: string
  ) {}
}

export class CreateAssetSuccess implements LoadingAction {
  readonly type = actions.CREATE_ASSET_SUCCESS;
  readonly isLoading = false;

  constructor(
    public assetType: string,
    public fileName: string,
    public size: number,
    public response: AssetUploadResponse,
    public metadata?: any,
    public trackingId?: string
  ) {}
}

export class GetAssetStatus implements LoadingAction {
  readonly type = actions.GET_ASSET_STATUS;
  readonly isLoading = true;

  constructor(
    public category: string,
    public ids: string[],
    public retryCounter: number = 0
  ) {}
}

export class GetAssetStatusSuccess implements LoadingAction {
  readonly type = actions.GET_ASSET_STATUS_SUCCESS;
  readonly isLoading = false;

  constructor(
    public category: string,
    public results: AssetValidationResults[],
    public retryCounter: number = 0
  ) {}
}

export class GetAssetStatusError implements ErrorAction {
  readonly type = actions.GET_ASSET_STATUS_ERROR;
  readonly isError = true;

  constructor(
    public category: string,
    public code: string,
    public retryCounter: number = 0
  ) {}
}

export class StartAssetUpload implements Action {
  readonly type = actions.START_ASSET_UPLOAD;

  constructor(public upload: AssetUpload) {}
}

export class UpdateAssetUpload<T extends keyof AssetUpload> implements Action {
  readonly type = actions.UPDATE_ASSET_UPLOAD;

  constructor(
    public assetId: string,
    public key: T,
    public value: AssetUpload[T]
  ) {}
}

export class FinishAssetUpload implements Action {
  readonly type = actions.FINISH_ASSET_UPLOAD;

  constructor(public assetId: string) {}
}

export class FinishAssetReplaceUpload implements Action {
  readonly type = actions.FINISH_ASSET_REPLACE_UPLOAD;

  constructor(public assetId: string) {}
}

export class CancelAssetUpload implements Action {
  readonly type = actions.CANCEL_ASSET_UPLOAD;

  constructor(public trackingId: string, public assetId?: string) {}
}

export class RemoveAssetUpload implements Action {
  readonly type = actions.REMOVE_ASSET_UPLOAD;

  constructor(public assetIds: string[]) {}
}

export class ClearAssets implements Action {
  readonly type = actions.CLEAR_ASSETS;
}

export type AssetsActions =
  | CreateAsset
  | ReplaceAsset
  | ReplaceAssetSuccess
  | CreateAssetSuccess
  | StartAssetUpload
  | UpdateAssetUpload<keyof AssetUpload>
  | FinishAssetUpload
  | FinishAssetReplaceUpload
  | CancelAssetUpload
  | RemoveAssetUpload
  | ClearAssets
  | GetAssetStatus
  | GetAssetStatusSuccess
  | GetAssetStatusError;
